import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { Sidebar } from 'semantic-ui-react'
import NavBar from 'Components/NavBar'
import SideBars from 'Components/SideBars'
import styles from './DashboardStyles.js'

const DashboardLayout = ({
  component: Component, authData, computedMatch, ...rest
}) => {
  return (
    <Route {...rest} render={matchProps => (
      authData['access-token']
        ? <div className={styles.DashboardLayout}>
            <Sidebar.Pushable>
              <SideBars matchProps={matchProps} />
              <Sidebar.Pusher>
                <div className={styles.content}>
                  <NavBar {...matchProps} />
                  <div className={styles.mainContent}>
                    <Component {...matchProps} />
                  </div>
                </div>
              </Sidebar.Pusher>
            </Sidebar.Pushable>
          </div>
        : <Redirect exact to={{
            pathname: '/auth/login',
            state: { referrer: matchProps.location }
          }} />
    )} />
  )
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData
})

export default connect(mapStateToProps, null)(DashboardLayout)



// WEBPACK FOOTER //
// ./src/Pages/Layouts/Dashboard.js